import './Service.css';
import Header from './components/Header';
import { ServiceGrid } from './components/ServiceGrid';
import { NavBar } from '../../utility/navBar/Navbar';
import { Contact } from '../../utility/contact/Contact';
import { useEffect } from 'react';

export const Service = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0});
    }, []);

    return (
        <section className={`service`}>
                <NavBar theme='light'/>
                <Header />
                <ServiceGrid />
                <Contact />
        </section>
        
    );
};